export default __webpack_public_path__ + "static/media/Level16.7c6f5277.svg";